import React, {useEffect} from 'react';
import {Text, View} from 'react-native';
import Plaque from '../../../components/plaque/Plaque.component';
import VehicleCard from '../../../components/vehicle-card/VehicleCard.component';
import CircleBattery from '../circle-battery/CircleBattery.component';
import styles from './SelectVehicleCard.style';

//this component is extends from Vehicle Card and add plaque and battery to it depending on design.
export default function SelectVehicleCard(props) {
  const {item} = props;

  useEffect(() => {
    console.log('SelectVehicleCard updated with new item:', item);
  }, [item]);
  return (
    <VehicleCard
      screen={'damage-list'}
      leftChildren={
        <CircleBattery screen={'selectVehicle'} value={item?.battery} />
      }
      containerStyle={styles.container}
      {...props}>
      <Plaque value={item?.plaque} containerStyle={styles.plaque} />

      <Text style={styles.name}>{item?.name}</Text>
    </VehicleCard>
  );
}
